import superAdminReducer, { SuperAdminState } from 'modules/app/redux/reducers/superAdmin';
import { combineReducers } from 'redux';
import importedOrganizationsModuleReducer, { ImportedOrganizationsState } from './organizations';

export type ImportedOrganizationModuleState = {
  importedOrganization: ImportedOrganizationsState;
  globalInfo: SuperAdminState;
};

const importedOrganizationModuleReducer = combineReducers({
  importedOrganization: importedOrganizationsModuleReducer,
  globalInfo: superAdminReducer,
});

export default importedOrganizationModuleReducer;
